import React from "react";
import { Link } from "react-router-dom";

const HERO = "/lookbook-fw26/knit-look-01.png";
const LOOK_1 = "/lookbook-fw26/knit-look-02.png";
const LOOK_2 = "/lookbook-fw26/knit-look-03.png";
const LOOK_3 = "/lookbook-fw26/knit-look-04.png";
const LOOK_4 = "/lookbook-fw26/knit-look-05.png";

const LOOKS = [
    { n: "01", title: "Dawn Layer", img: HERO, span: "lg:col-span-7 lg:row-span-2" },
    { n: "02", title: "Stairwell Soft", img: LOOK_1, span: "lg:col-span-5" },
    { n: "03", title: "Service Lift", img: LOOK_4, span: "lg:col-span-5" },
    { n: "04", title: "Accessory Study", img: LOOK_3, span: "lg:col-span-4" },
    { n: "05", title: "Boiler Room", img: LOOK_2, span: "lg:col-span-8" },
];

const Lookbook = () => {
    return (
        <div data-testid="lookbook-page">
            <section className="px-4 md:px-8 py-10 md:py-16 border-b-4 border-black">
                <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-hazard">
                    [Lookbook / Vol. 06]
                </span>
                <h1 className="font-heading text-6xl md:text-8xl lg:text-9xl uppercase leading-[0.85] mt-2">
                    Concrete
                    <br />
                    <span className="text-hazard">Hours.</span>
                </h1>
                <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed">
                    Knitwear rebuilt for the city before sunrise: sweaters layered over
                    hoodies, soft trousers swapped in for denim, and the same street
                    accessories carried through each frame. Five looks. One cold start.
                </p>
            </section>

            <section className="grid grid-cols-1 gap-0 border-b-4 border-black px-0 lg:grid-cols-12">
                {LOOKS.map((look, i) => (
                    <div
                        key={look.n}
                        className={`relative aspect-[4/5] overflow-hidden border-black lg:aspect-auto lg:min-h-[60vh] ${
                            i > 0 ? "border-t-2 lg:border-t-0" : ""
                        } ${i % 2 === 1 ? "lg:border-l-2" : ""} ${look.span}`}
                    >
                        <img
                            src={look.img}
                            alt={look.title}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute bottom-4 left-4 border-2 border-black bg-ink px-3 py-1.5 font-mono-ui text-[10px] uppercase tracking-[0.25em]">
                            Look {look.n} / {look.title}
                        </div>
                    </div>
                ))}
            </section>

            <section className="px-4 md:px-8 py-20 text-center">
                <h2 className="font-heading text-4xl md:text-6xl uppercase leading-none">
                    Shop The Edit
                </h2>
                <Link
                    to="/shop"
                    className="mt-8 inline-block border-2 border-black bg-ink px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.25em] text-black hover:border-hazard hover:bg-hazard"
                    data-testid="lookbook-shop-link"
                >
                    Shop FW26 →
                </Link>
            </section>
        </div>
    );
};

export default Lookbook;
